import React from 'react';
import {Flex, type FlexProps} from '@tempo/core';
import Title from './Title';
import Description from './Description';
import Button from './Button';

type SubComponents = {
	Title: typeof Title;
	Description: typeof Description;
	Button: typeof Button;
};

const Empty: React.FC<FlexProps> & SubComponents = ({children, ...props}) => (
	<Flex
		direction="column"
		align="center"
		my="spacing.l"
		textAlign="center"
		{...props}
	>
		{children}
	</Flex>
);

Empty.Title = Title;
Empty.Description = Description;
Empty.Button = Button;

export default Empty;
